import { PathMatch } from "react-router-dom";
import { APP_NAVIGATE_DIRECTION } from "../constants/app.constant";

export interface AppHistoryType {
	path: string;
}

export interface AppType {
	title: string;
	navigateDirection: APP_NAVIGATE_DIRECTION;
	history: AppHistoryType[];
	isRootScrollable: boolean;
	debugMode: boolean;
	backFromPath: AppHistoryType
	isWentBackAndToggledFalse: isWentBackAndToggledFalseEnum;
	triggerCloseApp:string,
}

export enum isWentBackAndToggledFalseEnum {
	FIRST_OPEN_PAGE = "firstOpenPage",
	WENT_BACK_AND_TOGGLE_FALSE = "wentBackAndToggleFalse",
	MAY_GO_BACK_AGAIN_BUT_HAVE_NOT_TOGGLE = "mayGoBackAgainButHaveNotToggle"
}

export interface AppHeaderEndButtonDisplayPathType {
	menu: Array<PathMatch<string> | null>;
	close: Array<PathMatch<string> | null>;
}
